<template>
  <div>
    <v-menu
      offset-y
      readonly
      :nudge-top="25"
      :close-on-content-click="false"
      bottom
      class="input-menu"
    >
      <template v-if="group.is_admin" v-slot:activator="{ attrs, on }">
        <v-text-field
          dense
          v-on="on"
          v-bind="attrs"
          v-model="value"
          :placeholder="`Add Securities`"
          background-color="#F3F9FF"
          outlined
          :suffix="!is_edit ? `${watchlist_items.length}/50` : ''"
        >
          <template v-slot:prepend-inner>
            <v-icon v-if="!is_edit">mdi-magnify</v-icon>
            <v-icon @click="is_edit = false" style="cursor: pointer" v-else
              >mdi-arrow-left-thin</v-icon
            >
          </template>
          <template v-slot:append>
            <div class="append-btn-icon">
              <div>
                <v-btn @click="is_edit = true" icon>
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
              </div>
            </div>
          </template>
        </v-text-field>
      </template>
      <v-card class="card-list">
        <v-list>
          <v-list-item v-for="(item, id) in items" :key="id.id">
            <v-list-item-title>
              <div class="d-flex justify-space-between align-center">
                <div class="d-flex justify-center align-center">
                  <div class="pr-2">
                    <v-chip-group mandatory>
                      <v-chip
                        active
                        small
                        label
                        outlined
                        :color="item.exchange == 'BSE' ? '#2D8CFF' : '#27AE60'"
                      >
                        {{ item.exchange }}
                      </v-chip>
                    </v-chip-group>
                  </div>
                  <div>
                    <div class="security-symbol">
                      {{ item.symbol }}
                    </div>
                    <div class="security-fullname">
                      {{ item.name }}
                    </div>
                  </div>
                </div>
                <div>
                  <v-img
                    class="cursor"
                    :src="plus_sign"
                    v-if="!item.is_added_to_watchlist"
                    @click="
                      addWatchlistOfSearch(item.id, item),
                        (item.is_added_to_watchlist = true)
                    "
                  ></v-img>

                  <v-img
                    class="cursor"
                    :src="minus_sign"
                    v-if="item.is_added_to_watchlist"
                    @click="
                      removeWatchlistOfSearch(item.watchlist_id),
                        (item.is_added_to_watchlist = false)
                    "
                  >
                  </v-img>
                </div>
              </div>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
    <div v-for="(element, id) in watchlist_items" :key="id.id" class="mb-2">
      <!-- <v-list-item> -->
      <div class="d-flex justify-space-between align-center mb-2">
        <div class="d-flex">
          <!-- <div class="drag-handle" v-if="is_drag">
            <v-btn icon class="">
              <v-icon>mdi-drag </v-icon>
            </v-btn>
          </div> -->
          <div>
            <div class="security-name">
              {{ element.stock_data.symbol }}
            </div>
            <div>
              <span>
                <v-chip small class="nse-bse">
                  {{ element.stock_data.exchange }}
                </v-chip>
              </span>
              <!-- <span>
                <v-img class="experience-img" :src="experience"></v-img
              ></span> -->
            </div>
          </div>
        </div>

        <div v-if="!is_edit">
          <div class="ratio text-right">
            {{ element.stock_data.live_price.toFixed(2) }}
          </div>
          <div
            class="percentage"
            :class="
              element.stock_data.live_price >= 0 ? 'green--text' : 'red--text'
            "
          >
            <span>
              {{
                retrunPveNve(element.stock_data.up_down_price.toFixed(2))
              }} </span
            ><span
              >({{ retrunPveNve(element.stock_data.up_down_percent) }}%)</span
            >
          </div>
        </div>
        <div class="delete-btn" v-if="is_edit">
          <v-btn
            @click="removeWatchlistOfSearch(element.id)"
            class="delete-button"
            depressed
          >
            <v-icon small> mdi-trash-can-outline</v-icon>
          </v-btn>
        </div>
      </div>
      <v-divider> </v-divider>
      <!-- </v-list-item> -->
    </div>
  </div>
</template>

<script>
import Axios from "@/api/BaseAxios.js";

export default {
  name: "WatchlistPremiumGroups",
  props: {
    watchlist_data: {
      type: Array,
      required: true,
    },
    group: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      value: "",
      is_edit: false,
      items: [],
      watchlist_items: [],
      plus_sign: require("@/assets/images/plus_sign.svg"),
      minus_sign: require("@/assets/images/minus_sign.svg"),
    };
  },
  watch: {
    value() {
      this.getSearchListItems();
    },
  },
  mounted() {
    if (this.watchlist_data[0].id) {
      this.getWatchListItems();
    }
  },
  methods: {
    retrunPveNve(value) {
      if (value >= 0) {
        return `+${value}`;
      } else {
        return value;
      }
    },

    deleteButton() {},

    getSearchListItems() {
      const successHandler = (res) => {
        this.items = res.data.result;
      };
      const failureHandler = () => {};
      let formData = {};
      formData["search"] = this.value;
      // formData["watcher_type"] = "stock";
      formData["watchlist"] = this.watchlist_data[0].id;
      Axios.request_GET(
        "api/group_watchlist/search",
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },

    async getWatchListItems() {
      const successHandler = (res) => {
        this.watchlist_items = res.data.result;
        this.eventBus.$emit("getwatchlist-length", this.watchlist_items.length);
      };
      const failureHandler = () => {};
      let formData = {};
      // formData["watchlist"] = id;
      // formData["watcher_type"] = "stock";
      formData["watchlist"] = this.watchlist_data[0].id;
      Axios.request_GET(
        "api/watchlist/detail/",
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },

    addWatchlistOfSearch(id) {
      const successHandler = () => {
        this.getSearchListItems();
        this.getWatchListItems();
      };
      const failureHandler = () => {};
      let formData = {};
      formData["watchlist"] = this.watchlist_data[0].id;
      formData["stock"] = id;
      Axios.request_POST(
        "api/watchlist/detail/",
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },

    removeWatchlistOfSearch(id) {
      const successHandler = () => {
        this.getSearchListItems();
        this.getWatchListItems();
      };
      const failureHandler = () => {};
      let formData = {};
      // formData["watchlist"] = this.watchlist_data[0].id;
      // formData["stock"] = id;
      formData["id"] = id;
      Axios.request_DELETE(
        "api/watchlist/detail/",
        formData,
        {},
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 768px) {
  .card-list {
    max-height: 155px !important;
    width: 100% !important;
  }
}
.card-list {
  max-height: 365px !important;
  width: 325px;
}
.cursor {
  cursor: pointer;
}
.append-btn-icon {
  margin-top: -8px;
}
.delete-btn > .v-btn:not(.v-btn--round).v-size--default {
  height: 37px;
  min-width: 46px;
  padding: 0px !important;
  background-color: #fff !important;
  border-radius: 0.375rem;
  border: 1px solid rgba(51, 51, 51, 0.8);
}
.ratio {
  color: var(--Green-2, #27ae60);
  text-align: center;
  font-family: Avenir;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.percentage {
  color: #434343;
  // text-align: center;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.security-name {
  color: #000;
  font-family: Avenir;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.nse-bse {
  background: rgba(130, 130, 130, 0.1) !important;
  font-family: Avenir;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
}
.security-fullname {
  color: rgba(51, 51, 51, 0.54);
  font-family: Avenir;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.security-symbol {
  color: #333;
  font-family: Avenir;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
</style>
